var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9.21 9.21a.99.99 0 0 0 0-1.404L6.405 5 9.21 2.194A.992.992 0 0 0 7.807.791L5 3.596 2.195.791A.992.992 0 1 0 .792 2.194L3.598 5 .791 7.806A.992.992 0 1 0 2.194 9.21l2.807-2.806 2.807 2.806a.99.99 0 0 0 1.403 0",
    clipRule: "evenodd"
  })));
};
export default SvgCross;